import { ListeningForm } from "../../components/Forms/ListeningForm";

const NewListening = () => {
  return <ListeningForm></ListeningForm>;
};

export default NewListening;
